<template>
  <!-- 碎片活动管理-添加碎片分区 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="type===1?'添加碎片分区':'编辑碎片分区'"
      width="350px"
      @close="closeDialog"
    >
      <el-form
        :model="dataForm"
        ref="dataForm"
        label-width="100px"
        size="small"
        :rules="replyRules"
      >
        <el-form-item prop="name" label="分组名称">
          <el-input placeholder="请输入分组名称" v-model="dataForm.name">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import { getCookie } from '../../utils/cookie'
import saveFile from '@/utils/saveFile'

export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      imgType: 'prize',//上传图片的种类 奖品
      dataForm: {
        name: '',
      },
      replyRules: {//回复弹窗规则验证
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.fromInfo) {
        this.dataForm = this.fromInfo
      }
    },
  },
  created() {
  },
  methods: {
    submit(id) {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      // this.dataForm.room = id
      let params = this.dataForm
      if (this.type === 1) {
        postApiData('debris_category', params).then(res => {
          this.$message.success("添加成功")
          this.$emit('refresh')
          this.closeDialog()
        }).finally(() => {
          this.buttonLoading = false
        })
      } else if (this.type === 2) {
        patchApiData(`debris_category/${this.dataForm.id}`, params).then(res => {
          this.$message.success("编辑成功")
          this.$emit('refresh')
          this.closeDialog()
        }).finally(() => {
          this.buttonLoading = false
        })
      }
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>